<div [floatUi]="tooltipcontent"
  [showTrigger]="popperTrigger"
  [placement]="popperPlacement"
  [applyClass]="'popperSpecialStyle'"
  [positionFixed]=true
  [appendTo]="'body'"
  [ariaRole]="'tooltip'"
  [hideTimeout]="300"
  #floatUiRef="floatUi">
  <span
    class="tooltip-info-trigger"
    [class.tooltip-info-trigger--on-dark]="iconColor === 'WHITE'"
    tabindex="0"
    role="img"
    [attr.title]="title || null"
    [attr.aria-label]="screenReaderText"
    [attr.aria-describedby]="tooltipcontent.id"
    [style.height]="heightInPx"
    [style.width]="widthInPx"
    (focus)="floatUiRef.show()"
    (blur)="floatUiRef.hide()">
    <svg-icon-sprite [src]="'assets/sprite/sprite.svg#icon-info'" [classes]="'icon-info' + (iconColor | iconButtonColorEnumPipe)" [width]="widthInPx" [height]="heightInPx"></svg-icon-sprite>
  </span>
</div>
<float-ui-content #tooltipcontent>
  @if (!isHtmlContent) {
    <span>{{screenReaderText}}</span>
  }
  @if (isHtmlContent) {
    <div [innerHTML]="screenReaderText"></div>
  }
</float-ui-content>

